import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  NbSidebarModule,
  NbThemeModule,
  NbMenuModule,
  NbIconModule,
  NbLayoutModule,
  NbOverlayModule,
  NbToastrModule,
  NbDialogModule,
  NbWindowModule,
} from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './core/auth/auth.interceptor';
import { provideNgxMask } from 'ngx-mask';
import { provideRouter } from '@angular/router';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideNgxMask(),
    importProvidersFrom(
      BrowserAnimationsModule,
      NbThemeModule.forRoot({ name: 'default' }),
      NbSidebarModule.forRoot(),
      NbOverlayModule.forRoot(),
      // Aviso e erro ficam 20s na tela: o tempo de ler a mensagem do backend inteira, que às
      // vezes é longa. Clicar dispensa antes.
      NbToastrModule.forRoot({ duration: 20000, destroyByClick: true }),
      NbMenuModule.forRoot(),
      NbDialogModule.forRoot(),
      NbWindowModule.forRoot(),
      NbEvaIconsModule,
      NbIconModule,
      NbLayoutModule,
    ),
  ],
};
